import { Base } from "../base";
import { Custom, IsAlphanumeric, IsNotEmpty, MaxLength, MinLength } from "@pineapplelab/validators"

export class UpdatePasswordDto extends Base {

	currentPassword: string = null;

	@IsNotEmpty({message: "login.password_empty"})
	@MinLength(8, { message: "login.password_minimum_message" })
	@Custom((object, field) => /\d/.test(object[field]), { message: "login.password_must_include_number" })
	newPassword: string = null;

	override toJson() {
		return super.toJson(true)
	}
}
